import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-toR",
  "use": "icon-toR-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-toR\"><defs><style type=\"text/css\"></style></defs><path d=\"M128 800h20.6l38.4-62.4c41-65.4 89.8-125.6 151.6-153.2 48.8-21.8 93.4-37.8 173.4-40V704l384-256-384-256v160.6C386 358.2 295.8 394 225.4 465 120.8 570.4 128 703 128 736.4c0.2 17.8 0 43.4 0 63.6z\" p-id=\"1843\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/toR.svg
// module id = U1mN
// module chunks = 31